import LayoutEffect from "../../LayoutEffect"
import SectionWrapper from "../../SectionWrapper"

const faqsList = [
    {
        q: "How do I create a virtual Visa card with Barrenpay?",
        a: "Creating a virtual Visa card with Barrenpay is easy. Simply sign up, follow the intuitive steps, and generate your virtual card instantly.",
    },
    {
        q: "Are Barrenpay's virtual Visa cards secure?",
        a: "Absolutely! Barrenpay prioritizes security. Our virtual Visa cards provide an extra layer of protection, safeguarding your actual card information during online transactions.",
    },
    {
        q: "Can I use Barrenpay's virtual Visa cards internationally?",
        a: "Yes! Barrenpay's virtual Visa cards are accepted globally, making them ideal for both domestic and international online purchases.",
    },
    {
        q: "Can I set spending limits on my Barrenpay virtual Visa card?",
        a: "Yes, you have full control. Barrenpay allows you to set customized spending limits, helping you manage your budget and prevent overspending",
    },
    {
        q: "What happens if I need to cancel a subscription with my Barrenpay virtual Visa card?",
        a: "Canceling subscriptions is hassle-free. Simply close the virtual card associated with the subscription, preventing any further charges from being processed.",
    },
    {
        q: "Is customer support available if I have any issues with my Barrenpay virtual Visa card?",
        a: "Absolutely! Barrenpay offers dedicated customer support to assist you with any questions or concerns regarding your virtual Visa card. Our team is here to help.",
    }
]

const FAQs = () => (
    <SectionWrapper id="faqs">
        <div className="custom-screen text-gray-300">
            <div className="max-w-xl text-center xl:mx-auto">
                <h2 className="text-gray-50 text-3xl font-extrabold sm:text-4xl">
                    Barrenpay Virtual Visa Cards FAQ's
                </h2>
                <p className="mt-3">
                FAQs: Creating and Managing Virtual Visa Cards with Barrenpay
                </p>
            </div>
            <div className='mt-12'>
                <LayoutEffect
                    className="duration-1000 delay-300"
                    isInviewState={{
                        trueState: "opacity-1",
                        falseState: "opacity-0 translate-y-12"
                    }}
                >
                    <ul className='space-y-8 gap-12 grid-cols-2 sm:grid sm:space-y-0 lg:grid-cols-3'>
                        {faqsList.map((item, idx) => (
                            <li
                                key={idx}
                                className="space-y-3"
                            >
                                <summary
                                    className="flex items-center justify-between font-semibold text-gray-100">
                                    {item.q}
                                </summary>
                                <p
                                    dangerouslySetInnerHTML={{ __html: item.a }}
                                    className='leading-relaxed'>
                                </p>
                            </li>
                        ))}
                    </ul>
                </LayoutEffect>
            </div>
        </div>
    </SectionWrapper>
)

export default FAQs